



























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import QuickSearchResult from './QuickSearchResult.vue';
import { SearchStore } from '@/store/searchstate';
import debounce from 'lodash/debounce';

@Component({
    components: {
        QuickSearchResult
    }
})
export default class QuickSearch extends Vue {
    @Prop()
    protected placeHolder!: string;
    @Prop()
    protected cssClass!: string;

    protected inputValue: string = '';

    protected focus: boolean = false;

    constructor() {
        super();
    }
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            if (query) {
                this.inputValue = query;
            }
        }
    }
    get queryValue(): string {
        return this.inputValue;
    }
    get result() {
        return SearchStore.searchResult;
    }
    get selectedItem() {
        return SearchStore.searchSelectedItem;
    }
    private handleKeys(event: KeyboardEvent) {
        SearchStore.saveSearchSelectedItem({ event, searchUrl: this.searchUrl });
    }
    private blurDelay(event: FocusEvent) {
        setTimeout(() => {
            if (!document.querySelector('#headerSearchBar.open')) this.focus = false;
            else (event.target as HTMLInputElement).focus();
        }, 300);
    }
    private debouncedQuery = debounce(val => SearchStore.saveSearchResult(val), 500);
    private getResult(val: string) {
        this.inputValue = val;
        this.debouncedQuery(val);
    }

    get searchUrl() {
        return (
            window.__litium.quickSearchUrl + (SearchStore.searchQuery.length > 0 ? `?q=${SearchStore.searchQuery}` : '')
        );
    }
}
